'use strict';

// Settings configured here will be merged into the final config object.
export default {
  SITE_NAME:"月刊メリヤスくんとメリーちゃん",
  THEME:"A", // A(Blog) or B(Media)
  PAGE_MAX:3
}



/** WEBPACK FOOTER **
 ** ./src/config/base.js
 **/